export const generateSeriesPercent = (value: number, denominator: number): number => {
  if (denominator === 0) return 0;
  const result = (value / denominator) * 100;
  return result;
};

export const generateSeriesPercentRound = (value: number, denominator: number): number => {
  if (denominator === 0) return 0;
  return Math.round((value / denominator) * 100);
};

export const deriveValueFromSeries = (series: number, denominator: number): number => {
  const percent = Number(series) / 100;
  const result = Math.round(denominator * percent);
  return result;
};
